import { EditOutlined, TrophyOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import React, { useEffect, useState } from "react";

import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import StudentHealthInfoForm from "../../components/forms/StudentHealthInfoForm.js";
import { fetchAllHealthInfos } from "../../store/healthInfoSlice.js";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck.js";
import AccessDenied from '../../hooks/AccessDenied'; // Adjust the import path
import { fetchStudentById } from "../../store/studentsSlice"; // Adjust path if needed

const StudentHealthInfo = () => {
  // const healthInfo = useSelector(healthInfoSelector);
  const healthInfo = useSelector((state) => state.healthInfo);
  const { healthInfoList, loading } = healthInfo;
const studentsById = useSelector((state) => state.students.byId);

  //  console.log("healthInfo", healthInfoList);
  const dispatch = useDispatch();
  useTokenExpiryCheck();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingHealthInfo, setEditingHealthInfo] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const storedUser = localStorage.getItem("userInfo");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  if (!userData) {
    throw new Error("No user data or token found");
  }
const roles = userData?.roles || [];
const isStudent = roles.includes("Student");
const isParent = roles.includes("Parent");
  console.log("userData", userData);
  console.log("isStudent", isStudent);
const studentIds = React.useMemo(() => {
  return isParent ? userData.studentIds : [userData.studentId];
}, [isParent, userData.studentIds, userData.studentId]);


const fetchedStudentsRef = React.useRef(new Set());

useEffect(() => {
  dispatch(fetchAllHealthInfos());

  studentIds.forEach((id) => {
    if (!fetchedStudentsRef.current.has(id)) {
      dispatch(fetchStudentById(id));
      fetchedStudentsRef.current.add(id);
    }
  });
}, []); // but then you cannot read updated studentIds here


  const handleEditHealthInfo = (record) => {
    setEditingHealthInfo(record);
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setEditingHealthInfo(null); // Clear editing state on cancel
  };

  const onSave = (cb) => {
    setSuccess(true);
    setIsModalOpen(false);
    dispatch(fetchAllHealthInfos());
    if (cb) cb();
  };

  const onSaveFail = (message, cb) => {
    setError(message);
    if (cb) cb();
  };
 if (!isStudent && !isParent) {
  return <AccessDenied />;
}
const fullName = (studentId) => {
  const student = studentsById[studentId];
  return student?.basicPersonalInformation
    ? `${student.basicPersonalInformation.firstName || ""} ${student.basicPersonalInformation.surName || ""} ${student.basicPersonalInformation.lastName || ""}`.trim()
    : "Student";
};

  return (
    <div className="flex ">
      <div className="grow-0">
        <div className="p-4">
          <div className="flex justify-between items-center m-4 mt-0">
            <h2 className="text-2xl font-bold">
              <TrophyOutlined style={{ marginRight: 8 }} />
              Student Health Information
            </h2>
          </div>
{(isParent || isStudent? userData.studentIds : [userData.studentId]).map((studentId) => {


            // Check if health information exists for this studentId
            console.log("Processing userData:", userData);
            console.log("Processing healthInfoList:", healthInfoList);
        const studentHealthInfo = healthInfoList?.find(
  (info) => info.studentId?.toLowerCase() === studentId?.toLowerCase()
);

            return (
              <div key={studentId} className="border p-4 m-2 rounded">
                <div className="flex justify-between">
                  <div>
                    {studentHealthInfo ? (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              backgroundColor: "green",
                              color: "white",
                            }}
                          >
                            <th style={{ textAlign: "left", padding: "8px" }}>
                              Health Information
                            </th>
                            <th style={{ textAlign: "left", padding: "8px" }}>
                              Result
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Reference Hospital Name
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.referenceHospital || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Hospital Phone Number
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.hospitalNumber || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Doctor Phone Number
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.doctorNumber || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Doctor Name
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.doctorName || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Health Description
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.healthDescription || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Vaccination Status
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.vaccinationStatus || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: "bold", padding: "8px" }}>
                              Vaccination Explanation
                            </td>
                            <td style={{ padding: "8px" }}>
                              {studentHealthInfo?.vaccinationExplanation ||
                                "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                ) : (
  <>
     {isParent && (
                <Button
                  type="primary"
                  onClick={() => {
                    setEditingHealthInfo(null);
                    setIsModalOpen(true);
                  }}
                >
                  Add Health Information for Student {fullName(studentId)}
                </Button>
              )}
              {isStudent && (
                <div>No health information available</div>
              )}
  </>
)}


                    {studentHealthInfo && (
                      <div style={{ textAlign: "right", marginTop: "16px" }}>
                       {isParent && (  <Button
                          type="primary"
                          icon={<EditOutlined />}
                          onClick={() =>
                            handleEditHealthInfo(studentHealthInfo)
                          } // Open modal for editing
                        >
                          Edit
                        </Button>)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
          {isModalOpen && (
            <StudentHealthInfoForm
              onSave={onSave}
              onSaveFail={onSaveFail}
              open={isModalOpen}
              onCancel={handleModalCancel}
              initialValues={editingHealthInfo} // Pass the edited health info or null for new
              mode={editingHealthInfo ? "edit" : "create"} // Determine mode
            />
          )}

          <Snackbar
            open={success}
            autoHideDuration={6000}
            onClose={() => setSuccess(false)}
          >
            <Alert
              onClose={() => setSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              Changes saved successfully!
            </Alert>
          </Snackbar>
          <Snackbar
            open={!!error}
            autoHideDuration={6000}
            onClose={() => setError(null)}
          >
            <Alert
              onClose={() => setError(null)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {error}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
};

export default StudentHealthInfo;
